import { Dialog, DialogContent } from "@material-ui/core";
import React from "react";
import { useRefresh } from "react-admin";
import { Form } from "react-final-form";
import CustomLinearProgress from "../../../../Components/Progress/LinearProgress";
import { UploadFile } from "../../../../Components/UploadFile";
import { PbhRequestFileType } from "../../../../Enums/PbhRequestFileType";
import { FileGrid } from "../../../../Components/FileGrid";

export const PbhStatusUpdateUploadFile = props => {
  const [open, setOpen] = React.useState(props.open);
  const [isLoading, setIsLoading] = React.useState(false);
  const refresh = useRefresh();

  React.useEffect(() => {
    setOpen(props.open);
  }, [props.open]);

  const handleClose = () => {
    setOpen(false);
    props?.handleClose?.();
  };

  return (
    <React.Fragment>
      <Dialog
        fullWidth={true}
        maxWidth={"xl"}
        open={open}
        onClose={handleClose}
        aria-labelledby="max-width-dialog-title"
      >
        <DialogContent>
          <Form
            onSubmit={() => {}}
            render={({ form, values }) => {
              return (
                <form>
                  <CustomLinearProgress loading={isLoading} />
                  {isLoading !== true && (
                    <>
                      <UploadFile
                        label=""
                        multiple={false}
                        placeholder={"Upload"}
                        onHandleFileExecute={refresh}
                        setIsLoading={setIsLoading}
                        source="pbhrequestorderfilerelations"
                        object={{
                          pbhRequestOrderId: props?.record?.requestId,
                          pbhRequestFileTypeGroupEnum: PbhRequestFileType.ManualUpdate,
                          pbhRequestFileTypeEnum: PbhRequestFileType.ManualUpdate,
                        }}
                      />
                    </>
                  )}
                </form>
              );
            }}
          />
          <FileGrid
            source="pbhrequestorderfilerelations"
            filter={{
              pbhRequestOrderId__eq: props?.record?.requestId,
              pbhRequestFileTypeGroupEnum__eq: PbhRequestFileType.ManualUpdate,
              PbhRequestFileTypeEnum__eq: PbhRequestFileType.ManualUpdate,
            }}
            showGroup={false}
            showFileType={false}
            canRemove={true}
            triggeted={() => {}}
          />
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};

export default PbhStatusUpdateUploadFile;
